export const SET_EMPRESA = "SET_EMPRESA";
export const SET_SUCURSAL = "SET_SUCURSAL";
export const SET_COMPRAS = "SET_COMPRAS";
export const SET_VENTAS = "SET_VENTAS";
export const SET_SUCURSALES = "SET_SUCURSALES";
export const SET_TOTALES_COMPRAS = "SET_TOTALES_COMPRAS";
export const SET_TOTALES_VENTAS = "SET_TOTALES_VENTAS";
export const CLIENT = "client";
export const ADMIN = "admin";